import { render, staticRenderFns } from "./CellRendererPhone.vue?vue&type=template&id=b36c4190"
import script from "./CellRendererPhone.vue?vue&type=script&lang=js"
export * from "./CellRendererPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports